<template>
  <div class="logo-in-header">
      <!-- <span class="logo" :style="customLogoStyle">
        <img src="/static/img/home/header_logo.png" alt="" />
      </span> -->
    <router-link to="/" aria-label="logo" v-show="linkToHome" class="logo">
      <img src="/static/img/home/header_logo.png" alt="" />
    </router-link>
  </div>
</template>

<script>
  export default {
    name: 'logo-in-header',
    props: {
      color: {type: String, default: '#fff', require: false},
      linkToHome: {type: Boolean, default: true, require: false},
      boxHeight: {type: Number, default: 0.6, require: false},
      fontSize: {type: Number, default: 1.2, require: false}
    },
    data() {
      return {
        linkDefaultWidth: 1.2,
        linkDefaultHeight: 0.3,
        logoDefaultHeight: 1.2
      }
    },
    computed: {
      zoomScale() {
        return this.fontSize / this.linkDefaultWidth
      },
      linkCurrentHeight() {
        return this.linkDefaultHeight * this.zoomScale
      },
      logoCurrentHeight() {
        return this.logoDefaultHeight * this.zoomScale
      },
      langIsZh() {
        return this.$store.state.currentLang === 'zh'
      },
      customLogoStyle() {
        return {
          'color': this.color,
          'top': (this.boxHeight - this.logoCurrentHeight) / 2 + 'rem',
          'fontSize': this.fontSize + 'rem'
        }
      },
      customLinkStyle() {
        return {
          'top': ((this.boxHeight - this.linkCurrentHeight) / 2) + 'rem',
          'fontSize': this.fontSize + 'rem',
          'width': (this.linkDefaultWidth * this.zoomScale) + 'rem',
          'height': (this.linkDefaultHeight * this.zoomScale) + 'rem'
        }
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";

  .logo-in-header {
    .logo img {
      width: 1.8rem;
      height: 0.4rem;
      cursor: pointer;
    }
    @media screen and (max-width: 991px) {
      .logo img {
        width: 1.26rem;
        height: .28rem;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// LogoInHeader.vue?24d9fcd8